import React from 'react'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { getCreateStore } from 'store'
import { handleRole } from './hooks/useAuthUtil'
const { store } = getCreateStore()
import * as ROLES from './store/role/constants'
import MaPageContianer from './containers/MaPageContianer'
import AuthProvider from './contexts/Auth.context'
import { history } from './helpers'

const webRole = handleRole(ROLES.ROLE_BUYER)

const App = () => {
  return (
    <React.Fragment>
      <Provider store={store}>
        <Router history={history} location={history.location} role={webRole}>
          <MaPageContianer>
            <AuthProvider history={history} role={webRole} />
          </MaPageContianer>
        </Router>
      </Provider>
    </React.Fragment>
  )
}

export default App
